const $ = require("jquery");
const rellax = require('../../../components/rellax/rellax.script');
const AOS_animation = require('../../../components/AOS-animation/AOS-animation.script');
export async function load() {

    $('#aceite').on('change',function(){
        if($(this).is(':checked')){
            $('.enviar').removeClass('disabled');
        }else{
            $('.enviar').addClass('disabled');
        }
    })

    try {
        await rellax.start('.rellax');
        await carroucel.start();
        await AOS_animation.start();
        return true


    } catch (err) {
        console.log('err', err)
        return err
    }


}
